<div class="container">
  <div class="user-list mt-3 mb-3" *ngIf="timePeriods.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">Mon</th>
        <th scope="col">Tue</th>
        <th scope="col">Wed</th>
        <th scope="col">Thu</th>
        <th scope="col">Fri</th>
        <th scope="col">Sat</th>
        <th scope="col">Sun</th>
        <th scope="col">Start Time</th>
        <th scope="col">End Time</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let timePeriod of timePeriods">
        <th scope="row">{{ timePeriod.id }}</th>
        <td class="text-center">{{ timePeriod.name }}</td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.monday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.tuesday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.wednesday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.thursday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.friday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.saturday"></td>
        <td class="text-center"><input type="checkbox" disabled [checked]="timePeriod.sunday"></td>
        <td class="text-center">{{ timePeriod.startTime }}</td>
        <td class="text-center">{{ timePeriod.endTime }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(timePeriod)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(timePeriod)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="timePeriods.length == 0">
    <p>You have no time periods yet</p>
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
